export default __webpack_public_path__ + "static/media/Gestion_Eficiente_imgn.20473f13.jpg";